import React from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { heroImages, tagline, foodImages, menuBoardImages, socialLinks } from '../data/mock';

const Menu = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-400 via-yellow-500 to-yellow-600 py-12">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-5xl md:text-6xl font-black mb-4 text-white">
            OUR <span className="text-black">MENU</span>
          </h1>
          <p className="text-xl text-white font-medium">Loaded with taste. Stuffed with love.</p>
          <p className="text-lg text-white font-bold mt-2 italic">"{tagline}"</p>
        </div>

        {/* Food Gallery */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {foodImages.map((image, index) => (
            <Card key={index} className="border-4 border-black overflow-hidden hover:shadow-2xl transition-all bg-white">
              <div className="relative h-80 overflow-hidden">
                <img
                  src={image}
                  alt={`देशी Stuff Paratha ${index + 1}`}
                  className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                />
              </div>
            </Card>
          ))}
        </div>

        {/* Menu Boards */}
        <div className="mb-12">
          <h2 className="text-4xl font-black text-center mb-8 text-white">
            COMPLETE <span className="text-black">MENU</span>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {menuBoardImages.map((image, index) => (
              <Card key={index} className="border-4 border-black overflow-hidden hover:shadow-2xl transition-all bg-black">
                <div className="relative overflow-hidden">
                  <img
                    src={image}
                    alt={`Menu Board ${index + 1}`}
                    className="w-full h-full object-contain hover:scale-105 transition-transform duration-500"
                  />
                </div>
              </Card>
            ))}
          </div>
        </div>

        {/* Menu Description */}
        <div className="max-w-3xl mx-auto text-center mb-12 bg-white border-4 border-black rounded-2xl p-8">
          <h3 className="text-3xl font-black text-black mb-6">WIDE VARIETY OF STUFFED PARATHAS</h3>
          <div className="space-y-4 text-gray-800 text-lg font-medium">
            <p>
              We serve authentic Punjabi stuffed parathas made fresh with quality ingredients. Every paratha is loaded with generous filling and topped with butter for that perfect taste.
            </p>
            <p>
              From classic flavors to special combinations - Paneer, Cheese, Aloo, Mix Veg, Gobi, and many more! Visit any of our outlets or order online via Zomato to explore our full menu!
            </p>
          </div>
        </div>

        {/* CTA Section */}
        <div className="text-center bg-black rounded-2xl p-12 shadow-2xl border-4 border-yellow-600">
          <h3 className="text-4xl font-black mb-4 text-yellow-400">VISIT US TO EXPLORE MENU!</h3>
          <p className="text-xl mb-8 font-bold text-yellow-300">Call us, order on WhatsApp, or find us on Zomato</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="tel:9601382424">
              <Button size="lg" className="text-lg font-bold bg-yellow-500 hover:bg-yellow-400 text-black px-8 py-6">
                Call 9601382424
              </Button>
            </a>
            <a href="https://wa.me/919601382424" target="_blank" rel="noopener noreferrer">
              <Button size="lg" variant="outline" className="text-lg font-bold border-2 border-yellow-500 text-yellow-400 hover:bg-yellow-500 hover:text-black px-8 py-6">
                Order on WhatsApp
              </Button>
            </a>
            <a href={socialLinks.zomato} target="_blank" rel="noopener noreferrer">
              <Button size="lg" className="text-lg font-bold bg-yellow-500 hover:bg-yellow-400 text-black px-8 py-6">
                Order on Zomato
              </Button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Menu;
